import { useEffect } from 'react';

import { useSyncStatus } from './useSyncStatus';

/**
 * On web browsers, prevents navigating away from the page (closing tab, refreshing)
 * while there are items pending sync (photos, scan data, notes).
 * No-op in non-browser environments (e.g., React Native).
 */
export const usePreventNavigationDuringSync = () => {
  const { photosSyncStatus } = useSyncStatus();
  const hasPendingSync = photosSyncStatus.pending > 0;

  useEffect(() => {
    if (!hasPendingSync || typeof document === 'undefined') return;

    const handler = (event: BeforeUnloadEvent) => {
      event.preventDefault();
    };

    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [hasPendingSync]);
};
